import { AuiIf, ComposerPrimitive } from "@assistant-ui/react";
import { ArrowUp, Square } from "lucide-react";
import { AGENT_NAME } from "./agentName";
import { composerStyles as s } from "./Composer.styles";

export function Composer() {
  return (
    <div className={s.root}>
      <p className={s.disclaimer}>AI-generated responses. Always verify.</p>
      <ComposerPrimitive.Root className={s.inner}>
        <ComposerPrimitive.Input
          rows={1}
          autoFocus
          placeholder={`${AGENT_NAME}…`}
          onInput={(e) => {
            const el = e.currentTarget;
            el.style.height = "auto";
            el.style.height = `${Math.min(el.scrollHeight, 120)}px`;
          }}
          className={s.input}
        />
        <AuiIf condition={(st) => !st.thread.isRunning}>
          <ComposerPrimitive.Send className={s.sendBtn}>
            <ArrowUp size={14} />
          </ComposerPrimitive.Send>
        </AuiIf>
        <AuiIf condition={(st) => st.thread.isRunning}>
          <ComposerPrimitive.Cancel className={s.cancelBtn}>
            <Square size={12} className="fill-current" />
          </ComposerPrimitive.Cancel>
        </AuiIf>
      </ComposerPrimitive.Root>
    </div>
  );
}
